import { render, staticRenderFns } from "./provideManage.vue?vue&type=template&id=1bcf15d2&"
import script from "./provideManage.vue?vue&type=script&lang=js&"
export * from "./provideManage.vue?vue&type=script&lang=js&"
import style0 from "./provideManage.vue?vue&type=style&index=0&id=1bcf15d2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports